import { Na } from './chunk-4H7AH4AK.js';
import { Router } from '@sevenrooms/navigation';
import { jsx } from 'react/jsx-runtime';

function p({children:o,theme:r="vx"}){return jsx(Router,{children:jsx(Na,{theme:r,children:o})})}function h({children:o,oldTheme:r}){return jsx(Router,{children:jsx(Na,{theme:"vx",themeOverride:r,children:o})})}function s({children:o}){return jsx(p,{theme:"gx",children:o})}async function f(o){try{await navigator.clipboard.writeText(o);}catch(r){console.error("Failed to copy text to clipboard:",r);}}function u(o,r,i){window.SvrManager=window.SvrManager||{},window.SvrManager[o]=window.SvrManager[o]||{},window.SvrManager[o][r]=i;}

export { p as a, h as b, s as c, f as d, u as e };
